import React from 'react'
import ReactDOM from 'react-dom'
import { createGlobalStyle } from 'styled-components'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Home from './concerns/screens/Home'
import * as serviceWorker from './serviceWorker'
import Privacy from './concerns/screens/Privacy'
import Terms from './concerns/screens/Terms'

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`

ReactDOM.render(
  <>
    <GlobalStyle />
    <Router>
      <Switch>
        <Route exact={true} path={'/privacy'} component={Privacy} />
        <Route exact={true} path={'/terms'} component={Terms} />
        <Route path={'/'} component={Home} />
      </Switch>
    </Router>
  </>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
